
export interface Department {
  code: string;
  name: string;
}

export interface City {
  name: string;
  code: string;
  dept: string;
}

export const departements: Department[] = [
  { code: "12", name: "Aveyron" },
  { code: "93", name: "Seine-Saint-Denis" },
  { code: "11", name: "Aude" },
  { code: "31", name: "Haute-Garonne" },
  { code: "34", name: "Hérault" },
  { code: "81", name: "Tarn" },
  { code: "46", name: "Lot" },
  { code: "48", name: "Lozère" },
  { code: "15", name: "Cantal" },
  { code: "75", name: "Paris" },
  { code: "92", name: "Hauts-de-Seine" },
  { code: "94", name: "Val-de-Marne" },
  { code: "95", name: "Val-d'Oise" },
  { code: "77", name: "Seine-et-Marne" },
  { code: "78", name: "Yvelines" },
  { code: "91", name: "Essonne" }
];

export const majorCities: City[] = [
  { name: "Rodez", code: "12000", dept: "12" },
  { name: "Millau", code: "12100", dept: "12" },
  { name: "Villefranche-de-Rouergue", code: "12200", dept: "12" },
  { name: "Saint-Denis", code: "93200", dept: "93" },
  { name: "Montreuil", code: "93100", dept: "93" },
  { name: "Beauchamp", code: "95250", dept: "95" },
  { name: "Toulouse", code: "31000", dept: "31" },
  { name: "Montpellier", code: "34000", dept: "34" },
  { name: "Albi", code: "81000", dept: "81" },
  { name: "Castres", code: "81100", dept: "81" },
  { name: "Carcassonne", code: "11000", dept: "11" },
  { name: "Cahors", code: "46000", dept: "46" },
  { name: "Mende", code: "48000", dept: "48" },
  { name: "Aurillac", code: "15000", dept: "15" },
  { name: "Paris", code: "75000", dept: "75" },
  { name: "Nanterre", code: "92000", dept: "92" },
  { name: "Créteil", code: "94000", dept: "94" },
  { name: "Cergy", code: "95000", dept: "95" },
  { name: "Melun", code: "77000", dept: "77" },
  { name: "Versailles", code: "78000", dept: "78" },
  { name: "Évry", code: "91000", dept: "91" }
];
